
<div class="filter-group" data-group-visibility-id="showGemHighlights">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showGemHighlights" (click)="filter.groupVisibility.showGemHighlights = !filter.groupVisibility.showGemHighlights; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Skill Gems" [activeRules]="activeRules.gemFiltersPoe1">
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showGemHighlights) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showGemHighlights">
      <div class="filter filter-property full-span" [class.disabled]="!filter.showTopTierAwakenedGems">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showTopTierAwakenedGems" (click)="toggleHighlightTopTierAwakenedGems()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Awakened Gems" [additionalContent]="topTierAwakenedGemsStylePreview" ruleId="gems-top-awakened">
            <strong>Awakened:</strong> {{ topAwakenedGems }}
            <br /><strong>Special:</strong> {{ topSpecialSupportGems }}
            <ng-template #topTierAwakenedGemsStylePreview>
              <app-equipment-tier-picker
                [isPoe1Gem]="true"
                [alignLeft]="true"
                [equipmentType]="EquipmentType.GemsTopTierAwakened"
                [active]="filter.showTopTierAwakenedGems"
                [exampleName]="'Awakened Enlighten Support'"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            [equipmentType]="EquipmentType.GemsTopTierSpecialSupport"
            filterPropertyName="showTopTierSpecialSupportGems"
            labelText="Special Support Gems"
            exampleName="Empower Support"
            [isPoe1Gem]="true"></app-filter-checkbox-group>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showTopTierExceptionalSupportGems">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showTopTierExceptionalSupportGems" (click)="toggleHighlightTopTierExceptionalSupportGems()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Top Exceptional {{ isMobile() ? 'Gems' : 'Support Gems' }}" [additionalContent]="topTierExceptionalSupportGemsStylePreview" ruleId="gems-top-exceptional-support">
            <strong>Top:</strong> {{ topExceptionalSupportGems }}
            <br /><strong>Other:</strong> {{ otherExceptionalSupportGems }}
            <ng-template #topTierExceptionalSupportGemsStylePreview>
              <app-equipment-tier-picker
                [isPoe1Gem]="true"
                [alignLeft]="true"
                [equipmentType]="EquipmentType.GemsTopTierSpecialSupport"
                [active]="filter.showTopTierSpecialSupportGems"
                [exampleName]="'Eclipse Support'"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            [equipmentType]="EquipmentType.GemsOtherExceptionalSupport"
            filterPropertyName="showOtherExceptionalSupportGems"
            labelText="Other Exceptional {{ isMobile() ? 'Gems' : 'Support Gems' }}"
            exampleName="Other Exceptional Support"
            [isPoe1Gem]="true"></app-filter-checkbox-group>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showImbuedGems">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showImbuedGems" (click)="toggleHighlightImbuedGems()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Imbued Gems" [additionalContent]="imbuedGemsStylePreview" ruleId="gems-imbued">
            <ng-template #imbuedGemsStylePreview>
              <app-equipment-tier-picker
                [isPoe1Gem]="true"
                [alignLeft]="true"
                [equipmentType]="EquipmentType.GemsImbued"
                [active]="filter.showImbuedGems"
                [exampleName]="'Imbued Gem'"></app-equipment-tier-picker>
            </ng-template>
          </span>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showLvl21Gems">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showLvl21Gems" (click)="toggleHighlightLvl21Gems()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Level 21 Gems" [additionalContent]="lvl21GemsStylePreview" ruleId="gems-level-21">
            <ng-template #lvl21GemsStylePreview>
              <app-equipment-tier-picker
                [isPoe1Gem]="true"
                [alignLeft]="true"
                [equipmentType]="EquipmentType.GemsLvl21"
                [active]="filter.showLvl21Gems"
                [exampleName]="'Example Support (Level 21)'"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            [equipmentType]="EquipmentType.GemsLevel"
            filterPropertyName="showLevelGems"
            labelText="Level 18+ Gems"
            exampleName="Example Support (Level 18)"
            [isPoe1Gem]="true"
            [dependentProperties]="['showOtherLevelGems']"></app-filter-checkbox-group>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showQuality23Gems">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showQuality23Gems" (click)="toggleHighlightQuality23Gems()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="{{ isMobile() ? '23Q Gems' : '23 Quality Gems' }}" [additionalContent]="quality23GemsStylePreview" ruleId="gems-quality-23">
            <ng-template #quality23GemsStylePreview>
              <app-equipment-tier-picker
                [isPoe1Gem]="true"
                [alignLeft]="true"
                [equipmentType]="EquipmentType.GemsQuality23"
                [active]="filter.showQuality23Gems"
                [exampleName]="'Superior Example Gem'"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            [equipmentType]="EquipmentType.GemsQuality"
            filterPropertyName="showQualityGems"
            [labelText]="isMobile() ? 'Q Gems' : 'Quality Gems'"
            exampleName="Superior Example Gem"
            [isPoe1Gem]="true"
            [dependentProperties]="['showOtherQualityGems']"></app-filter-checkbox-group>
          <span class="sep"></span>
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
            [disabled]="!filter.showQualityGems"
            [(ngModel)]="filter.showQualityGemsMinQuality" (change)="updateFilter()">
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            [equipmentType]="EquipmentType.GemsOtherQuality"
            filterPropertyName="showOtherQualityGems"
            [labelText]="isMobile() ? 'Other Q Gems' : 'Other Quality Gems'"
            exampleName="Superior Example Gem"
            [isPoe1Gem]="true"></app-filter-checkbox-group>
        </span>
      </div>

      <div class="filter filter-property" style="width: 100%;">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showSearchedGems" (click)="toggleHighlightSearchedGems()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Favourite Gems" [additionalContent]="searchedGemsStylePreview" ruleId="gems-my">
            This will highlight the <span class="gem-color">Gems</span> you are looking for for your build. You can bulk import them by copy/pasting the text from your (Path of Building or other) build guide.
            <ng-template #searchedGemsStylePreview>
              <app-equipment-tier-picker
                [isPoe1Gem]="true"
                [alignLeft]="true"
                [equipmentType]="EquipmentType.GemsSearched"
                [active]="filter.showSearchedGems"
                [exampleName]="'Example Gem'"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <button type="button" class="btn btn-default" (click)="bulkImportDialogOpen = true" style="width: 40px; min-width: 40px" title="Bulk Import">
            <span class="icon icon-download"></span>
          </button>
          <span class="sep"></span>
          <app-autocomplete
            [allLabel]="'None'"
            [options]="gemTypes"
            [disabled]="false"
            [showOptions]="true"
            [selectedValues]="filter.showSearchedGemTypes"
            (selectedValuesChange)="filter.showSearchedGemTypes = $event; updateFilter();"></app-autocomplete>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.hideOtherGems">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.hideOtherGems" (click)="toggleHideOtherGems()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Hide Other Gems">
            Transfigured and Trarthan Gems will never be hidden.
          </span>
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            filterPropertyName="hideOtherGemsExceptVaalGems"
            labelText="Except Vaal Gems"></app-filter-checkbox-group>
        </span>
      </div>
    </div>
    <div class="clear"></div>
  }
</div>

@if (bulkImportDialogOpen) {
  <app-bulk-import-gems-dialog (close)="bulkImportDialogOpen = false" (import)="importGems($event)"></app-bulk-import-gems-dialog>
}
